import { useState } from "react";
import { Stack } from "@/core/components/ui/stack";
import { Typography } from "@/core/components/ui/typography";
import { DocumentIconFor } from "./document-icon";
import { ExamplePreviewModal } from "./example-preview-modal";
import type { DocumentExample } from "./types";

interface DocumentExampleListProps {
  examples: readonly DocumentExample[];
}

// Open an example in place. It is reference material to read, not a file the customer
// must collect before they can continue.
export const DocumentExampleList = ({ examples }: DocumentExampleListProps) => {
  const [selectedExample, setSelectedExample] =
    useState<DocumentExample | null>(null);

  if (!examples.length) return null;

  return (
    <Stack gap="sm" align="stretch" fullWidth>
      <Typography variant="captionW1" textColor="tertiary">
        Examples
      </Typography>
      <Stack gap="xs" align="stretch" fullWidth>
        {examples.map((example) => (
          <button
            key={example.href}
            type="button"
            onClick={() => setSelectedExample(example)}
            className="group flex w-full items-center gap-2 text-left"
          >
            <DocumentIconFor
              fileName={example.href}
              className="h-5 w-5 shrink-0 text-tertiary-text"
            />
            <span className="min-w-0 flex-1 truncate text-md text-primary underline-offset-4 group-hover:underline">
              {example.label}
            </span>
          </button>
        ))}
      </Stack>

      <ExamplePreviewModal
        example={selectedExample}
        onClose={() => setSelectedExample(null)}
      />
    </Stack>
  );
};
